import { useMemo } from 'react'
import { startCase } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { InternalTransferTransactionSubType } from 'pages/WalletDetails/components/RecentActivity/SidePanel/PaymentTemplates/InternalTransfer'
import { TransactionType } from 'types/transaction/TransactionType'

interface UseTransactionHistoryLabelProps {
  transactionType: string
  transactionSubType: string
  name: string
  fallback: string
}
export const useTransactionHistoryLabel = ({
  transactionType,
  transactionSubType,
  name,
  fallback,
}: UseTransactionHistoryLabelProps) => {
  const { t } = useTranslation()

  return useMemo(() => {
    const isNetworkOrInternalTransfer =
      transactionType === TransactionType.BVNK_NETWORK_TRANSFER ||
      transactionType === TransactionType.INTERNAL_TRANSFER

    if (isNetworkOrInternalTransfer) {
      const isPayout = transactionSubType === InternalTransferTransactionSubType.PAYMENT_OUT
      const isPayin = transactionSubType === InternalTransferTransactionSubType.PAYMENT_IN

      if (isPayout) {
        return t('transactions.sideBar.networkTransferTo', {
          networkMember: name,
        })
      } else if (isPayin) {
        return t('transactions.sideBar.networkTransferFrom', {
          networkMember: name,
        })
      }

      return startCase(transactionType)
    } else {
      return fallback
    }
  }, [transactionType, transactionSubType, name, fallback, startCase])
}
